import type { OnInit } from '@angular/core';
import type { WidgetErrorItem } from '@common/types/widget-errors.type';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-save-confirm-modal',
    templateUrl: './save-confirm-modal.component.html',
    styleUrls: ['./save-confirm-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, TranslateModule],
})
export class SaveConfirmModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);

    public onClose: Subject<boolean>;
    public errors: WidgetErrorItem[];
    public exit: boolean;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public get getConfirmButtonTranslations(): string {
        if (this.exit) {
            return 'save_and_exit';
        }

        return 'save';
    }
}
